import React, { Component, Fragment } from 'react';
import CheckboxModifierContent from './CheckboxModifierContent';
import ToppingModifierContent from './ToppingModifierContent';
export default class ModifierGroup extends Component {
    constructor(props) {
        super(props);
        this.numberOfSelections = this.numberOfSelections.bind(this);
        this.showAppropriateContentSection = this.showAppropriateContentSection.bind(this);
        this.selectionAvailability = this.selectionAvailability.bind(this);
        this.bootstrapID = Math.floor((Math.random() * 12345678901) * Math.random()).toString();
    }

    numberOfSelections() {
        let numSel = 0;
        this.props.modifiers.map( (val, ind, arr) => {
            let choice = this.props.choices[val];
            numSel = numSel + choice.quantity;
            if(choice.size === 'extra') {
                numSel = numSel + 1;
            }
        });
        return numSel;
    }

    selectionAvailability() {
        if(this.props.maxAllowed === 0) {
            //no maximum, just display choices
            return this.numberOfSelections();
        } else {
            return `${this.numberOfSelections()} / ${this.props.maxAllowed}`;
        }
    }

    showAppropriateContentSection() {
        let shouldShow = this.props.index === 0;
        if(this.props.isTopping) {
            return <ToppingModifierContent
                shouldShow={shouldShow}
                bootstrapID={this.bootstrapID}
                modifiers={this.props.modifiers}
                allModifiers={this.props.allModifiers}
                setFirstHalf={this.props.setFirstHalf}
                setSecondHalf={this.props.setSecondHalf}
                setWhole={this.props.setWhole}
                setExtra={this.props.setExtra}
                setLight={this.props.setLight}
                setNormal={this.props.setNormal}
                removeModifier={this.props.removeModifier}
                choices={this.props.choices}
                selectedMainItem={this.props.selectedMainItem}
                itemGroup={this.props.itemGroup}
            />
        }else {
                return <CheckboxModifierContent
                    shouldShow={shouldShow}
                    bootstrapID={this.bootstrapID}
                    modifiers={this.props.modifiers}
                    allModifiers={this.props.allModifiers}
                    setWhole={this.props.setWhole}
                    setExtra={this.props.setExtra}
                    setLight={this.props.setLight}
                    setNormal={this.props.setNormal}
                    removeModifier={this.props.removeModifier}
                    choices={this.props.choices}
                    handleModifierQuantityChange={this.props.handleModifierQuantityChange}
                    increaseModifierQuantity={this.props.increaseModifierQuantity}
                    decreaseModifierQuantity={this.props.decreaseModifierQuantity}
                    showDouble={this.props.showDouble}
                    showHalf={this.props.showHalf}
                    selectedMainItem={this.props.selectedMainItem}
                    itemGroup={this.props.itemGroup}
                />
        }
    }

    render() {
        let old = (
            <div className='card'>
                <div className="card-header" id={`heading${this.bootstrapID}`}>
                    <h3 className="mb-0">
                        <button className="btn btn-link accent" type="button" data-toggle="collapse" data-target={`#collapse${this.bootstrapID}`} aria-expanded="true" aria-controls={`collapse${this.bootstrapID}`}>
                            {`${this.props.name} (${this.selectionAvailability()})`}
                        </button>
                    </h3>
                </div>
                {this.showAppropriateContentSection()}
            </div>
        );
        return (
            <div role="tabpanel" className={`tab-pane fade ${this.props.index === 0 && "show active"}`} id={this.props.name} aria-labelledby={`${this.props.name}-tab`}>
                {this.showAppropriateContentSection()}
            </div>
        )
    }
}